import KeyResult from 'components/framework/models/KeyResult';
import RecordFields from '../RecordFields';
import { registerRecordFieldsClasses } from './index';

export default class KeyResultFields extends RecordFields {
  static modelClass = KeyResult;
}

registerRecordFieldsClasses({ KeyResultFields });
